// // src/components/GoogleLoginButton.tsx
// import React from 'react';
// import { GoogleLogin } from '@react-oauth/google';

// interface GoogleLoginButtonProps {
//   onSuccess: (credentialResponse: any) => void;
//   onFailure: (error: any) => void;
// }

// const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onSuccess, onFailure }) => {
//   return (
//     <GoogleLogin
//       onSuccess={onSuccess}
//       onError={() => {
//         console.log('Login Failed');
//         onFailure('Login Failed');
//       }}
//       useOneTap
//     />
//   );
// };

// export default GoogleLoginButton;

// src/components/GoogleLoginButton.tsx
import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

interface GoogleLoginButtonProps {
  onSuccess: (credentialResponse: any) => void;
  onFailure: (error: any) => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onSuccess, onFailure }) => {
  return (
    <GoogleLogin
      onSuccess={onSuccess}
      onError={() => {
        console.log('Error de inicio de sesión de Google.');
        onFailure('Error de inicio de sesión de Google');
      }}
      useOneTap // Opcional: Habilita el "One Tap" para una experiencia más fluida
      text="signin_with" // Puedes personalizar el texto del botón
      theme="filled_blue" // Opcional: Estilo visual del botón
      size="large" // Opcional: Tamaño del botón
    />
  );
};

export default GoogleLoginButton;